import type { WorkQueue } from '../api/types.ts';

/**
 * Everything open in the selection, as GET /work counts it: the sum of its
 * counts. The sidebar badge, Today's line and its first figure are this number,
 * and it is the work queue's "All" tab — the page the figure opens.
 */
export function openWorkTotal(queue: WorkQueue | null): number | null {
  return queue === null ? null : Object.values(queue.counts).reduce((total, n) => total + n, 0);
}
